import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
      
    {/* <Test /> */}
  </React.StrictMode>,
  document.getElementById('root')
);